import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MeshStats } from '@usimweb/core/models';

@Component({
    selector: 'app-viewer-information',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './viewer-information.component.html',
    styleUrls: ['./viewer-information.component.scss'],
    standalone: false
})
export class ViewerInformationComponent {
  @Input() mesh: MeshStats = {
    numCells: 0,
    hCoarse: 0,
    maxSurfaceRefinementLevel: 0,
    gravityX: 0,
    gravityY: 0,
    gravityZ: 0,
    volume: 0,
    previewScale: '',
  };
}
